import { canManageUsers } from '../components/settings/UsersRolesPage';
import { isSuperAdmin } from '../components/admin/SuperAdminGuard';

/**
 * IDI-659 D3: who may run a dealer's setup — Users & Roles' rule (role
 * "admin"; never a field tech), minus IDI super-admins (IDI-63 refuses them
 * setup on a dealer). UI only; the server is the boundary.
 */
export function isSetupAdmin(user) {
  return canManageUsers(user) && !isSuperAdmin(user);
}

export default isSetupAdmin;
